import {
  TOASTER_ADD_DANGER,
  TOASTER_ADD_INFO,
  TOASTER_ADD_SUCCESS,
  TOASTER_ADD_WARNING,
} from 'containers/Toaster/constants';
import {
  type PutEffect,
  type SelectEffect,
  put,
  select,
} from 'redux-saga/effects';

import { selectLanguage } from 'containers/LanguageProvider/selectors';
import { translationMessages } from 'i18n';
import type { AppTranslations } from 'translations/translations';
import type { NotificationType } from 'utils/hooks/useNotifications';

const messageType = (type: NotificationType) => {
  switch (type) {
    case 'danger':
      return TOASTER_ADD_DANGER;
    case 'success':
      return TOASTER_ADD_SUCCESS;
    case 'info':
      return TOASTER_ADD_INFO;
    case 'warning':
      return TOASTER_ADD_WARNING;
    default:
      return TOASTER_ADD_INFO;
  }
};

export function* requestMessage(
  type: NotificationType,
  id: keyof AppTranslations['request'],
  replaceFn = (t: string) => t,
): Generator<SelectEffect | PutEffect> {
  // not worthy typing legacy code
  const language: any = yield select(selectLanguage);
  yield put({
    type: messageType(type),
    payload: {
      message: replaceFn(
        translationMessages[language.get('locale')].request[id],
      ),
    },
  });
}
